import { createAction, props } from '@ngrx/store'
import { KnowledgeAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const actionPrefix = '[dashboard]'

export const save_knowledge_action = createAction(
  `${actionPrefix} save_knowledge_action`,
  props<{ knowledge: KnowledgeAPIModel; files: File[]; routeTo: string }>()
)

export const save_knowledge_success_action = createAction(
  `${actionPrefix} save_knowledge_success_action`,
  props<{ knowledge: KnowledgeAPIModel }>()
)

export const UPDATE_KNOWLEDGE_ARTICLE_ACTION = createAction(
  `${actionPrefix} update_activity_action`,
  props<{ knowledgeArticle: Partial<KnowledgeAPIModel>; id: string; files: File[]; routeTo: string }>()
)

export const UPDATE_KNOWLEDGE_ARTICLE_SUCCESS_ACTION = createAction(
  `${actionPrefix} update_activity_success_action`,
  props<{ knowledgeArticle: KnowledgeAPIModel; routeTo: string }>()
)

export const view_knowledge_action = createAction(
  `${actionPrefix} view_knowledge_action`,
  props<{ id: string; includeDocumentLinks: boolean }>()
)

export const view_knowledge_success_action = createAction(
  `${actionPrefix} view_knowledge_success_action`,
  props<{ knowledge: KnowledgeAPIModel }>()
)

export const search_knowledge_success_action = createAction(
  `${actionPrefix} search_knowledge_success_action`,
  props<{ knowledge: PaginatedAPI<KnowledgeAPIModel> }>()
)

export const search_knowledge_action = createAction(
  `${actionPrefix} search_knowledge_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: KnowledgeAPIModel
    routeTo: string
  }>()
)

export const LOAD_KNOWLEDGE_SUMMARY_DETAILS = createAction(
  `${actionPrefix} load_knowledge_summary_details`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS = createAction(
  `${actionPrefix} load_knowledge_summary_details_success`,
  props<{ knowledge: PaginatedAPI<KnowledgeAPIModel> }>()
)

export const load_knowledge_quick_option_details = createAction(
  `${actionPrefix} load_knowledge_quick_option_details`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const load_knowledge_quick_option_details_success = createAction(
  `${actionPrefix} load_knowledge_quick_option_details_success`,
  props<{ knowledge: PaginatedAPI<KnowledgeAPIModel> }>()
)

export const PUBLISH_KNOWLEDGE_ARTICLE_ACTION = createAction(
  `${actionPrefix} PUBLISH_KNOWLEDGE_ARTICLE_ACTION`,
  props<{ id: string }>()
)
